// extracted by mini-css-extract-plugin
export default {"container":"Processing_container__A0ivw","title":"Processing_title__QXREF","content":"Processing_content__S+8wJ"};